import Icon from 'veui/components/Icon'
import { IconPlayCircle } from 'dls-icons-vue'

Icon.register('play-circle', IconPlayCircle)
